(() => {
  const root = document.documentElement;
  if (root.dataset.dalucaImageOnlyPinch === 'true') return;
  root.dataset.dalucaImageOnlyPinch = 'true';
  root.style.touchAction = 'pan-x pan-y';
  const preventPagePinch = (event) => {
    if (event.cancelable && (event.type.startsWith('gesture') || event.touches?.length > 1)) {
      event.preventDefault();
    }
  };
  ['touchstart', 'touchmove', 'gesturestart', 'gesturechange'].forEach((type) => {
    document.addEventListener(type, preventPagePinch, { capture: true, passive: false });
  });
})();

(() => {
  const root = document.documentElement;
  root.dataset.dalucaFocusInput = 'pointer';
  ['pointerdown', 'touchstart'].forEach((type) => {
    document.addEventListener(type, () => { root.dataset.dalucaFocusInput = 'pointer'; }, { capture: true, passive: true });
  });
  document.addEventListener('keydown', (event) => {
    if (['Tab', 'Enter', ' '].includes(event.key)) root.dataset.dalucaFocusInput = 'keyboard';
  }, true);
})();

window.DaLucaCartLines = (() => {
  let pending = Promise.resolve();
  const errorText = () => document.querySelector('[data-cart-error]')?.dataset.cartError || '';
  const root = () => (window.Shopify?.routes?.root || '/').replace(/\/?$/, '/');
  const careHandles = new Set(['venetian-cream-3oz', 'venetian-cream-4oz', 'venetian-cream-leather-shine-cloth', 'extra-standard-spring-bars', 'spring-bar-buckle-removal-tool', 'spring-bar-tool']);
  const independentCare = item => careHandles.has(item.handle) && !item.properties?._gpo_parent_product_group && !item.parent_relationship?.parent_key;
  const linkedService = item => item.properties?.['_DaLuca linked upgrade'] === 'true' && !independentCare(item) && !item.properties?._gpo_parent_product_group && !item.parent_relationship?.parent_key;
  async function request(path, payload) {
    const response = await fetch(root() + path, {
      method: payload ? 'POST' : 'GET',
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      ...(payload ? { body: JSON.stringify(payload) } : {})
    });
    const cart = await response.json();
    if (!response.ok || cart.errors || Number(cart.status) >= 400) {
      throw new Error(cart.description || cart.message || cart.errors || errorText());
    }
    return cart;
  }
  const qrStorageKey = 'daluca-qr-quantity-v1';
  const checkoutSelector = '[name="checkout"],.checkout-button,.shopify-payment-button,.additional-checkout-buttons,.cart__dynamic-checkout-buttons,shopify-accelerated-checkout,shopify-accelerated-checkout-cart,[data-shopify-buttoncontainer],.daluca-cart-edit-link';
  const guardedCheckout = new Map();
  let qrRecord = readQrRecord();
  let qrError = '';
  const signature = properties => JSON.stringify(Object.keys(properties || {}).sort().reduce((out, name) => {
    if (properties[name] !== '' && properties[name] != null) out[name] = String(properties[name]);
    return out;
  }, {}));
  const reference = item => ({ key: item.key, variant_id: String(item.variant_id), properties: item.properties || {},
    sellingPlan: String(item.selling_plan_allocation?.selling_plan?.id || ''), quantity: Number(item.quantity) });
  const matches = (item, ref) => String(item.variant_id) === String(ref.variant_id) &&
    signature(item.properties) === signature(ref.properties) &&
    String(item.selling_plan_allocation?.selling_plan?.id || '') === ref.sellingPlan;
  function identify(cart, ref, allowMissing = false) {
    const candidates = cart.items.filter(item => matches(item, ref));
    if (!candidates.length && allowMissing) return null;
    if (candidates.length !== 1) throw new Error('We could not identify this strap and its upgrade. Please refresh your cart and try again.');
    return candidates[0];
  }
  function readQrRecord() {
    try { return JSON.parse(sessionStorage.getItem(qrStorageKey) || 'null'); } catch (_) { return null; }
  }
  function saveQrRecord(value) {
    sessionStorage.setItem(qrStorageKey, JSON.stringify(value));
    if (sessionStorage.getItem(qrStorageKey) !== JSON.stringify(value)) throw new Error('Please enable browser storage before updating this strap.');
    qrRecord = value;
    syncQrUi();
  }
  function clearQrRecord() {
    sessionStorage.removeItem(qrStorageKey);
    qrRecord = null;
    qrError = '';
    syncQrUi();
  }
  function syncQrUi() {
    const blocked = !!qrRecord;
    document.documentElement.toggleAttribute('data-daluca-qr-quantity-pending', blocked);
    const controls = new Set(blocked ? document.querySelectorAll(checkoutSelector) : []);
    if (blocked) document.querySelectorAll('a[href]').forEach(link => {
      if (/\/checkouts?(?:\/|\?|$)/i.test(link.pathname || '')) controls.add(link);
    });
    guardedCheckout.forEach((prior, control) => {
      if (controls.has(control)) return;
      control.inert = prior.inert;
      if ('disabled' in control) control.disabled = prior.disabled;
      if (prior.aria === null) control.removeAttribute('aria-disabled'); else control.setAttribute('aria-disabled', prior.aria);
      guardedCheckout.delete(control);
    });
    controls.forEach(control => {
      if (!guardedCheckout.has(control)) guardedCheckout.set(control, { inert: !!control.inert, disabled: !!control.disabled, aria: control.getAttribute('aria-disabled') });
      control.inert = true;
      if ('disabled' in control) control.disabled = true;
      if (control.getAttribute('aria-disabled') !== 'true') control.setAttribute('aria-disabled', 'true');
    });
    let notice = document.getElementById('DaLucaQrQuantityStatus');
    if (!qrError) { if (notice) notice.remove(); return; }
    if (!notice) {
      notice = document.createElement('div'); notice.id = 'DaLucaQrQuantityStatus'; notice.setAttribute('role', 'alert');
      const copy = document.createElement('p'); copy.dataset.dalucaQrMessage = 'true'; notice.appendChild(copy);
      const retry = document.createElement('button'); retry.type = 'button'; retry.className = 'button'; retry.textContent = 'Check strap quantity';
      retry.addEventListener('click', () => {
        retry.disabled = true;
        const run = pending.then(() => recoverQrQuantity());
        pending = run.catch(() => {}).finally(() => { retry.disabled = false; });
      });
      notice.appendChild(retry);
      (document.querySelector('theme-cart,.cart-drawer,main') || document.body).prepend(notice);
    }
    const copy = notice.querySelector('[data-daluca-qr-message]');
    if (copy.textContent !== qrError) copy.textContent = qrError;
  }
  async function setQuantity(cart, ref, quantity, sections) {
    const line = identify(cart, ref, quantity === 0);
    if (!line) return cart;
    if (Number(line.quantity) === quantity) return cart;
    return request('cart/change.js', { id: line.key, quantity, sections, sections_url: window.location.pathname });
  }
  function verifyQrQuantity(cart, record, quantity) {
    return Number(identify(cart, record.parent, quantity === 0)?.quantity || 0) === quantity &&
      record.services.every(ref => {
        const expected = quantity === record.target ? Number(ref.target ?? record.target) : Number(ref.originalTarget ?? record.parent.quantity);
        return Number(identify(cart, ref, expected === 0)?.quantity || 0) === expected;
      });
  }
  async function reconcileQrQuantity(record, sections, keepOriginal = false) {
    let cart = await request('cart.js');
    const references = [record.parent, ...record.services];
    if (references.every(ref => !cart.items.some(item => item.key === ref.key || matches(item, ref)))) {
      return { cart, completed: true };
    }
    const parent = identify(cart, record.parent, record.target === 0);
    // A lost response may have committed the requested strap quantity. Finish that
    // request; otherwise restore the original strap quantity before releasing checkout.
    const quantity = !keepOriginal && Number(parent?.quantity || 0) === record.target ? record.target : record.parent.quantity;
    cart = await setQuantity(cart, record.parent, quantity, sections);
    for (const service of record.services) cart = await setQuantity(cart, service,
      quantity === record.target ? Number(service.target ?? record.target) : Number(service.originalTarget ?? record.parent.quantity), sections);
    if (!verifyQrQuantity(cart, record, quantity)) throw new Error('Unable to confirm the strap and upgrade quantities.');
    return { cart, completed: quantity === record.target };
  }
  async function recoverQrQuantity() {
    if (!qrRecord) return;
    try {
      let result;
      try { result = await reconcileQrQuantity(qrRecord, []); }
      catch (_) { result = await reconcileQrQuantity(qrRecord, [], true); }
      clearQrRecord();
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      return result;
    } catch (failure) {
      qrError = 'We could not confirm the strap and upgrade quantities. Check the quantity before checkout.';
      syncQrUi();
      throw failure;
    }
  }
  async function changeQrQuantity(item, services, target, sections) {
    const record = { parent: reference(item), services: services.map(service => ({ ...reference(service), target: service.target ?? target, originalTarget: service.originalTarget ?? Number(item.quantity) })), target };
    saveQrRecord(record);
    try {
      let cart;
      if (target === 0) {
        const updates = { [item.key]: 0 };
        record.services.forEach(service => { updates[service.key] = service.target; });
        cart = await request('cart/update.js', { updates, sections, sections_url: window.location.pathname });
      } else {
        cart = await request('cart/change.js', { id: item.key, quantity: target, sections, sections_url: window.location.pathname });
      }
      if (Number(identify(cart, record.parent, target === 0)?.quantity || 0) !== target) throw new Error('The requested strap quantity is unavailable.');
      for (const service of record.services) cart = await setQuantity(cart, service, service.target, sections);
      if (!verifyQrQuantity(cart, record, target)) throw new Error('Unable to confirm the strap and upgrade quantities.');
      clearQrRecord();
      return cart;
    } catch (failure) {
      try {
        let result;
        try { result = await reconcileQrQuantity(record, sections); }
        catch (_) { result = await reconcileQrQuantity(record, sections, true); }
        clearQrRecord();
        if (result.completed) return result.cart;
      } catch (_) {
        qrError = 'We could not confirm the strap and upgrade quantities. Check the quantity before checkout.';
        syncQrUi();
        throw new Error(qrError);
      }
      throw failure;
    }
  }
  async function change(key, quantity, sections) {
    if (qrRecord) await recoverQrQuantity();
    const before = await request('cart.js');
    const item = before.items.find(item => item.key === key);
    if (!item) throw new Error(errorText());
    const target = Number(quantity);
    if (!Number.isSafeInteger(target) || target < 0) throw new Error(errorText());
    if (item.properties?._gpo_parent_product_group || item.parent_relationship?.parent_key) {
      throw new Error('This option follows its strap. Use Edit options on the strap to change it.');
    }
    if (linkedService(item)) {
      throw new Error('Quick-release follows its strap quantity. Change or remove the strap to update this upgrade.');
    }
    const itemOptions = signature(item.properties);
    const services = before.items.filter(line => {
      const p = line.properties || {};
      if (!linkedService(line) || String(p['_DaLuca parent variant']) !== String(item.variant_id)) return false;
      let options;
      try { options = signature(JSON.parse(p['_DaLuca parent options'])); }
      catch (_) { throw new Error('We could not identify the linked upgrade. Please refresh your cart and try again.'); }
      return options === itemOptions;
    });
    if (services.length) {
      const parents = before.items.filter(line => String(line.variant_id) === String(item.variant_id) && signature(line.properties) === itemOptions);
      // Never allocate a shared, discount-split service by guessing which strap owns it.
      if (services.length !== 1 || parents.length !== 1) throw new Error('We could not identify this strap and its upgrade. Please refresh your cart and try again.');
    }
    const customGroup = item.properties?._gpo_product_group;
    if (customGroup) {
      const parents = before.items.filter(line => String(line.properties?._gpo_product_group || '') === String(customGroup) && !line.properties?._gpo_parent_product_group && !line.parent_relationship?.parent_key);
      const parentQuantity = parents.reduce((sum, line) => sum + Number(line.quantity), 0);
      const nextParentQuantity = parentQuantity - Number(item.quantity) + target;
      if (!Number.isSafeInteger(parentQuantity) || parentQuantity < Number(item.quantity) || !Number.isSafeInteger(nextParentQuantity)) {
        throw new Error('We could not identify the custom option quantities. Please refresh your cart and try again.');
      }
      before.items.filter(line => String(line.properties?._gpo_parent_product_group || '') === String(customGroup)).forEach(line => {
        const numerator = Number(line.quantity) * nextParentQuantity;
        if (line.properties?._gpo_product_group || line.parent_relationship?.parent_key || !Number.isSafeInteger(numerator) || numerator % parentQuantity !== 0) {
          throw new Error('We could not identify the custom option quantities. Please refresh your cart and try again.');
        }
        services.push({ ...line, target: numerator / parentQuantity, originalTarget: Number(line.quantity) });
      });
    }
    if (services.length) {
      identify(before, reference(item));
      services.forEach(service => identify(before, reference(service)));
      return changeQrQuantity(item, services, target, sections);
    }
    if (target === 0) {
      const parentOptions = signature(item.properties);
      const remaining = before.items.filter(line => line.key !== key);
      const linked = before.items.filter(line => {
        const p = line.properties || {};
        if (independentCare(line)) return false;
        // Preserve service linkage for carts created before the explicit association.
        return /^Quick-Release Spring Bar Upgrade$/i.test(line.product_title || '') &&
          p['For strap'] === item.product_title &&
          !remaining.some(parent => parent.product_title === item.product_title);
      });
      if (linked.length) {
        const updates = { [key]: 0 };
        linked.forEach(line => { updates[line.key] = 0; });
        return request('cart/update.js', { updates, sections, sections_url: window.location.pathname });
      }
    }
    return request('cart/change.js', { id: key, quantity: target, sections, sections_url: window.location.pathname });
  }
  document.addEventListener('click', event => {
    if (!qrRecord) return;
    const control = event.target.closest(checkoutSelector + ',a[href]');
    if (!control || (!control.matches(checkoutSelector) && !/\/checkouts?(?:\/|\?|$)/i.test(control.pathname || ''))) return;
    event.preventDefault(); event.stopImmediatePropagation();
  }, true);
  document.addEventListener('submit', event => {
    if (!qrRecord || !event.target.querySelector('[name="checkout"]')) return;
    event.preventDefault(); event.stopImmediatePropagation();
  }, true);
  if (document.body) new MutationObserver(() => { if (qrRecord) syncQrUi(); }).observe(document.body, { childList: true, subtree: true });
  if (qrRecord) {
    syncQrUi();
    pending = Promise.resolve().then(() => recoverQrQuantity()).catch(() => {});
  }
  return { change(key, quantity, sections) {
    const result = pending.then(() => change(key, quantity, sections));
    pending = result.catch(() => {});
    return result;
  } };
})();

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

var dispatchCustomEvent = function dispatchCustomEvent(eventName) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var detail = {
    detail: data
  };
  var event = new CustomEvent(eventName, data ? detail : null);
  document.dispatchEvent(event);
};

/**
 *  Shopify standard events (shopify:*) — guarded publisher
 *  https://shopify.dev/docs/storefronts/themes/best-practices/standard-events
 *  Analytics must never break a commerce flow: every dispatch is guarded
 *  and errors are contained here.
 */
var publishStandardEvent = function (eventName, payload, target) {
  const SE = window.Shopify && window.Shopify.StandardEvents;
  if (!SE || !SE[eventName]) return;
  try {
    (target || document).dispatchEvent(new SE[eventName](payload || {}));
  } catch (e) {
    console.error('Standard event failed:', eventName, e);
  }
};

/**
 *  Converts an AJAX cart (/cart.js shape) to the Storefront shape the
 *  standard events expect. Returns null when conversion is not possible.
 */
var standardEventCart = function (ajaxCart) {
  const SE = window.Shopify && window.Shopify.StandardEvents;
  if (!SE || !SE.CartLinesUpdateEvent || typeof SE.CartLinesUpdateEvent.createCartFromAjaxResponse !== 'function') return null;
  if (!ajaxCart || !ajaxCart.token || !ajaxCart.items) return null;
  try {
    return SE.CartLinesUpdateEvent.createCartFromAjaxResponse(ajaxCart);
  } catch (e) {
    return null;
  }
};

window.recentlyViewedIds = [];

const OverlayManager = {
  stack: [],
  beforeCloseHandlers: new Map(),
  lastFocused: new Map(),
  _trapHandler: null,
  focusableSelector: 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])',

  trapFocus(e) {
    if (e.key !== 'Tab' || !this.stack.length) return;
    const panel = this.stack[this.stack.length - 1];
    const focusable = Array.from(panel.querySelectorAll(this.focusableSelector)).filter((el) => el.getClientRects().length);
    if (!focusable.length) {
      e.preventDefault();
      return;
    }
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    const inside = panel.contains(document.activeElement);
    if (e.shiftKey) {
      if (!inside || document.activeElement === first) {
        last.focus();
        e.preventDefault();
      }
    } else if (!inside || document.activeElement === last) {
      first.focus();
      e.preventDefault();
    }
  },

  open(panel) {
    if (!panel || this.stack.includes(panel)) return;
    this.lastFocused.set(panel, document.activeElement);
    if (!this.stack.length) {
      this._trapHandler = this.trapFocus.bind(this);
      document.addEventListener('keydown', this._trapHandler);
    }
    this.stack.push(panel);
    panel.classList.add('active');
    panel.inert = false;
    document.body.classList.add('open-cc');
    panel.querySelector('.side-panel-close')?.focus();
    dispatchCustomEvent('panel:open', { panel });
  },

  close(panel) {
    if (!panel) return;
    const handler = this.beforeCloseHandlers.get(panel);
    if (handler) {
      handler(() => this._close(panel));
    } else {
      this._close(panel);
    }
  },

  _close(panel) {
    const index = this.stack.indexOf(panel);
    if (index > -1) this.stack.splice(index, 1);
    panel.classList.remove('active');
    panel.inert = true;
    if (!this.stack.length) {
      document.body.classList.remove('open-cc');
      if (this._trapHandler) {
        document.removeEventListener('keydown', this._trapHandler);
        this._trapHandler = null;
      }
    }
    const lastFocused = this.lastFocused.get(panel);
    this.lastFocused.delete(panel);
    if (!this.stack.length && lastFocused && document.contains(lastFocused)) {
      lastFocused.focus();
    }
    dispatchCustomEvent('panel:closed', { panel });
  },

  closeLast() {
    const panel = this.stack[this.stack.length - 1];
    if (panel) this.close(panel);
  },

  registerBeforeClose(panel, handler) {
    this.beforeCloseHandlers.set(panel, handler);
  },

  isOpen(panel) {
    return this.stack.includes(panel);
  },

  hasOpen() {
    return this.stack.length > 0;
  }
};

/**
 *  @class
 *  @function Quantity
 */
window.DaLucaQuantityFeedback = {
  show(message) {
    if (!message) return;
    let notice = document.getElementById('DaLucaQuantityFeedback');
    if (!notice) {
      notice = document.createElement('div');
      notice.id = 'DaLucaQuantityFeedback';
      notice.className = 'daluca-quantity-feedback';
      notice.setAttribute('role', 'alert');
      notice.setAttribute('aria-atomic', 'true');
      document.body.appendChild(notice);
    }
    notice.textContent = message;
    notice.hidden = false;
    clearTimeout(this.timer);
    this.timer = setTimeout(() => { notice.hidden = true; }, 7000);
  },
  limit(selector, maximum) {
    this.show(maximum >= 10
      ? '10+ available. Please choose a lower quantity or contact us for a larger order.'
      : (selector.dataset.maximumMessage || '').replace('[quantity]', String(maximum)));
  }
};

if (!customElements.get('quantity-selector')) {
  class QuantityInput extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('.qty');
      if (this.closest('.daluca-pdp--ooak:not(.daluca-pdp--custom)')) {
        this.input.value = '1';
        this.input.min = '1';
        this.input.max = '1';
        this.input.dataset.max = '1';
      }
      this.step = Number(this.input.getAttribute('step')) || 1;
      this.lastValidValue = this.input.value;
      this.changeEvent = new Event('change', { bubbles: true });
      this.subtract = this.querySelector('.minus');
      this.add = this.querySelector('.plus');
      this.subtract.addEventListener('click', () => this.change_quantity(-this.step));
      this.add.addEventListener('click', () => this.change_quantity(this.step));
      ['input', 'change'].forEach(type => this.input.addEventListener(type, event => this.enforceMaximum(event)));
      this.input.addEventListener('keydown', event => {
        if (event.key === 'ArrowUp' && Number(this.input.value) >= this.maximum) {
          event.preventDefault();
          window.DaLucaQuantityFeedback.limit(this, this.maximum);
        }
      });
      this.input.addEventListener('invalid', event => {
        if (this.input.validity.rangeOverflow) {
          event.preventDefault();
          window.DaLucaQuantityFeedback.limit(this, this.maximum);
        }
      });
    }
    connectedCallback() {
      this.classList.add('buttons_added');
    }
    get maximum() {
      const value = this.input.getAttribute('max');
      return value === null || value === '' ? Infinity : Number(value);
    }
    enforceMaximum(event) {
      if (Number(this.input.value) > this.maximum) {
        this.input.value = this.lastValidValue;
        event.stopImmediatePropagation();
        window.DaLucaQuantityFeedback.limit(this, this.maximum);
      } else if (this.input.value && this.input.validity.valid) {
        this.lastValidValue = this.input.value;
      }
    }
    updateLimits(source) {
      ['min', 'max', 'step', 'data-min', 'data-max'].forEach(name => {
        if (source.hasAttribute(name)) this.input.setAttribute(name, source.getAttribute(name));
        else this.input.removeAttribute(name);
      });
      this.step = Number(this.input.step) || 1;
      if (this.maximum > 0 && Number(this.input.value) > this.maximum) {
        this.input.value = this.maximum;
        window.DaLucaQuantityFeedback.limit(this, this.maximum);
      }
      this.lastValidValue = this.input.value;
      this.input.dispatchEvent(this.changeEvent);
    }
    change_quantity(change) {
      const quantity = (Number(this.input.value) || 1) + change;
      if (quantity < Math.max(Number(this.input.min) || 1, 1)) return;
      if (quantity > this.maximum) {
        window.DaLucaQuantityFeedback.limit(this, this.maximum);
        return;
      }
      this.input.value = quantity;
      this.lastValidValue = this.input.value;
      this.input.dispatchEvent(this.changeEvent);
    }
  }
  customElements.define('quantity-selector', QuantityInput);
}



/**
 *  @class
 *  @function ProductCard
 */
if (!customElements.get('product-card')) {
  class ProductCard extends HTMLElement {
    constructor() {
      super();
      this.swatches = this.querySelector('.product-card-swatches');
      this.image = this.querySelector('.product-featured-image-link .product-primary-image');
      this.secondary = this.querySelector('.product-featured-image-link .product-secondary-image');
      this.quick_add = this.querySelector('.product-card--add-to-cart-button-simple');
    }
    connectedCallback() {
      if (this.swatches) {
        this.enableSwatches();
      }
      if (this.quick_add) {
        this.enableQuickView();
      }
      if (this.secondary) {
        window.addEventListener('load', (event) => {
          lazySizes.loader.unveil(this.secondary);
        });
      }
    }
    enableSwatches() {
      let swatch_list = this.swatches.querySelectorAll('.product-card-swatch'),
        org_srcset = this.image ? this.image.dataset.srcset : '';


      swatch_list.forEach((swatch, index) => {
        window.addEventListener('load', (event) => {
          let image = new Image();
          image.srcset = swatch.dataset.srcset;
          lazySizes.loader.unveil(image);
        });
        swatch.addEventListener('mouseover', () => {

          [].forEach.call(swatch_list, function (el) {
            el.classList.remove('active');
          });
          if (this.image) {
            if (swatch.dataset.srcset) {
              this.image.setAttribute('srcset', swatch.dataset.srcset);
            } else {
              this.image.setAttribute('srcset', org_srcset);
            }
          }

          swatch.classList.add('active');
        });
        swatch.addEventListener('click', function (evt) {
          window.location.href = this.dataset.href;
          evt.preventDefault();
        });
      });
    }
    enableQuickView() {
      this.quick_add.addEventListener('click', this.quickAdd.bind(this));
    }

    quickAdd(evt) {
      evt.preventDefault();
      if (this.quick_add.disabled) {
        return;
      }
      this.quick_add.classList.add('loading');
      this.quick_add.setAttribute('aria-disabled', true);

      const config = {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/javascript'
        }
      };

      let formData = new FormData(this.form);

      formData.append('id', this.quick_add.dataset.productId);
      formData.append('quantity', 1);
      formData.append('sections', this.getSectionsToRender().map((section) => section.section));
      formData.append('sections_url', window.location.pathname);

      config.body = formData;

      fetch(`${theme.routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            return;
          }
          this.renderContents(response);

          dispatchCustomEvent('cart:item-added', {
            product: response.hasOwnProperty('items') ? response.items[0] : response
          });
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.quick_add.classList.remove('loading');
          this.quick_add.removeAttribute('aria-disabled');
        });

      return false;
    }
    getSectionsToRender() {
      return [{
        id: 'Cart',
        section: 'main-cart',
        selector: '.thb-cart-form'
      },
      {
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-item-count'
      }];
    }
    renderContents(parsedState) {
      this.getSectionsToRender().forEach((section => {
        if (!document.getElementById(section.id)) {
          return;
        }
        const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        const cartEl = document.getElementById('Cart');
        if (cartEl && cartEl.renderContents) {
          cartEl.renderContents(parsedState);
        }
      }));


      if (document.getElementById('Cart-Drawer')) {
        document.getElementById('Cart-Drawer').open();
      }

    }
    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }
  }
  customElements.define('product-card', ProductCard);
}

/**
 *  @class
 *  @function PanelClose
 */
class PanelClose extends HTMLElement {

  connectedCallback() {
    this.setAttribute('role', 'button');
    this.tabIndex = 0;
  }

  constructor() {
    super();
    this.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        this.click();
      }
    });
    let cc = document.querySelector('.click-capture');

    this.addEventListener('click', (e) => {
      e.preventDefault();
      let panel = e.target.closest('.side-panel');
      OverlayManager.close(panel);
    });
    document.addEventListener('keyup', (e) => {
      if (e.code && e.code.toUpperCase() === 'ESCAPE') {
        OverlayManager.closeLast();
      }
    });
    cc.addEventListener('click', () => {
      OverlayManager.closeLast();
    });
  }
}
customElements.define('side-panel-close', PanelClose);

/**
 *  @class
 *  @function CartDrawer
 */
if (!customElements.get('cart-drawer')) {
  class CartDrawer extends HTMLElement {

    constructor() {
      super();
    }
    connectedCallback() {
      let button = document.getElementById('cart-drawer-toggle');

      if (!button) {
        return;
      }
      button.addEventListener('click', (e) => {
        e.preventDefault();
        this.open();
      });

      this.debouncedOnChange = debounce((event) => {
        this.onChange(event);
      }, 300);

      this._onCartRefresh = () => this.refresh();
      document.addEventListener('cart:refresh', this._onCartRefresh);

      this.addEventListener('change', this.debouncedOnChange.bind(this));
      this.addEventListener('cart:remove', (event) => {
        this.updateQuantity(event.detail.index, '0');
      });
    }
    disconnectedCallback() {
      if (this._onCartRefresh) {
        document.removeEventListener('cart:refresh', this._onCartRefresh);
      }
    }
    open() {
      OverlayManager.open(this);
      dispatchCustomEvent('cart-drawer:open');
    }
    close() {
      OverlayManager.close(this);
    }
    onChange(event) {
      if (event.target.classList.contains('qty')) {
        this.updateQuantity(event.target.dataset.index, event.target.value);
      }
    }
    getSectionsToRender() {
      return [{
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-item-count'
      }];
    }
    getSectionInnerHTML(html, selector) {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }

    async updateQuantity(line, quantity) {
      if (this.dataset.dalucaUpdating === 'true') return;
      const row = this.querySelector(`#CartDrawerItem-${line}`);
      const key = row?.querySelector('quantity-selector')?.dataset.id;
      if (!key) return;
      this.dataset.dalucaUpdating = 'true';
      this._dalucaRefreshVersion = (this._dalucaRefreshVersion || 0) + 1;
      row.classList.add('thb-loading');
      dispatchCustomEvent('line-item:change:start', { quantity });
      try {
        const parsedState = await window.DaLucaCartLines.change(key, quantity, this.getSectionsToRender().map(section => section.section));
        if (!this.renderContents(parsedState.sections)) this._dalucaRefreshQueued = true;
        dispatchCustomEvent('line-item:change:end', { quantity, cart: parsedState });
        document.querySelector('theme-cart')?.refresh();
      } catch (error) {
        window.DaLucaQuantityFeedback?.show(error.message || this.dataset.cartError);
        this._dalucaRefreshQueued = true;
      } finally {
        this.dataset.dalucaUpdating = 'false';
        row.classList.remove('thb-loading');
        if (this._dalucaRefreshQueued) {
          this._dalucaRefreshQueued = false;
          this.refresh();
        }
      }
    }
    async refresh() {
      if (this.dataset.dalucaUpdating === 'true') {
        this._dalucaRefreshQueued = true;
        return false;
      }
      const version = this._dalucaRefreshVersion = (this._dalucaRefreshVersion || 0) + 1;
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 15000);
      try {
        const sections = this.getSectionsToRender().map(section => section.section).join(',');
        const response = await fetch(`${window.location.pathname}?sections=${sections}`, { cache: 'no-store', signal: controller.signal });
        if (!response.ok) throw new Error(this.dataset.cartError);
        const parsedState = await response.json();
        if (version !== this._dalucaRefreshVersion || this.dataset.dalucaUpdating === 'true') return false;
        if (parsedState.errors || !this.renderContents(parsedState)) throw new Error(this.dataset.cartError);
        return true;
      } catch (error) {
        if (version === this._dalucaRefreshVersion && this.dataset.dalucaUpdating !== 'true') {
          window.DaLucaQuantityFeedback?.show(this.dataset.cartError);
        }
        return false;
      } finally {
        clearTimeout(timeout);
      }
    }
    renderContents(parsedState) {
      const updates = [];
      for (const section of this.getSectionsToRender()) {
        const host = document.getElementById(section.id);
        if (!host) continue;
        const html = parsedState?.[section.section];
        if (typeof html !== 'string') return false;
        const fragment = new DOMParser().parseFromString(html, 'text/html').querySelector(section.selector);
        if (!fragment) return false;
        updates.push({ element: host.querySelector(section.selector) || host, html: fragment.innerHTML });
      }
      updates.forEach(update => { update.element.innerHTML = update.html; });
      return true;
    }
  }
  customElements.define('cart-drawer', CartDrawer);
}

/**
 *  @class
 *  @function QuickView
 */
if (!customElements.get('quick-view')) {
  const quickViewCache = new Map();

  class QuickView extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.drawer = document.getElementById('Product-Drawer');
      this.addEventListener('click', this.handleClick.bind(this));

      OverlayManager.registerBeforeClose(this.drawer, (proceed) => {
        this.drawer.querySelector('#Product-Drawer-Content').innerHTML = '';
        proceed();
      });
    }
    handleClick(e) {
      e.preventDefault();
      let productHandle = this.dataset.productHandle;
      if (!productHandle) {
        return;
      }
      let rootUrl = theme.routes.root_url.replace(/\/+$/, '');
      let href = `${rootUrl}/products/${productHandle}?view=quick-view`;

      if (this.classList.contains('loading')) {
        return;
      }
      this.classList.add('loading');

      if (QuickView.activeController) {
        QuickView.activeController.abort();
      }
      let controller = new AbortController();
      QuickView.activeController = controller;

      if (quickViewCache.has(productHandle)) {
        this.classList.remove('loading');
        this.renderQuickView(quickViewCache.get(productHandle), href, productHandle);
        return;
      }

      fetch(href, {
        method: 'GET',
        signal: controller.signal
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error(`Quick view fetch failed: ${response.status}`);
          }
          return response.text();
        })
        .then(text => {
          let parsed = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('#Product-Drawer-Content');

          if (!parsed) {
            throw new Error('Quick view content not found in response');
          }
          let sectionInnerHTML = parsed.innerHTML;
          quickViewCache.set(productHandle, sectionInnerHTML);
          this.renderQuickView(sectionInnerHTML, href, productHandle);
        })
        .catch((error) => {
          if (error.name !== 'AbortError') {
            console.error(error);
          }
        })
        .finally(() => {
          this.classList.remove('loading');
        });
    }
    _reloadScripts(container) {
      let scripts = container.querySelectorAll('script');
      let head = document.head;
      scripts.forEach((oldScript) => {
        let newScript = document.createElement('script');
        Array.from(oldScript.attributes).forEach((attr) => {
          newScript.setAttribute(attr.name, attr.value);
        });
        if (oldScript.src) {
          if (document.querySelector(`script[src="${oldScript.src}"]`)) {
            return;
          }
        } else {
          newScript.textContent = oldScript.textContent;
        }
        if (oldScript.parentNode) {
          oldScript.parentNode.replaceChild(newScript, oldScript);
        } else {
          head.appendChild(newScript);
        }
      });
    }
    renderQuickView(sectionInnerHTML, href, productHandle) {
      if (!sectionInnerHTML) {
        return;
      }
      let drawerContent = this.drawer.querySelector('#Product-Drawer-Content');
      drawerContent.innerHTML = sectionInnerHTML;

      this._reloadScripts(drawerContent);

      requestAnimationFrame(() => {
        if (typeof Shopify !== 'undefined' && Shopify.PaymentButton) {
          Shopify.PaymentButton.init();
        }
        if (window.ProductModel) {
          window.ProductModel.loadShopifyXR();
        }
      });

      OverlayManager.open(this.drawer);

      dispatchCustomEvent('quick-view:open', {
        productUrl: href,
        productHandle: productHandle
      });
      addIdToRecentlyViewed(productHandle);
    }
  }
  QuickView.activeController = null;
  customElements.define('quick-view', QuickView);
}

/**
 *  @class
 *  @function ProductRecommendations
 */
class ProductRecommendations extends HTMLElement {
  constructor() {
    super();

  }
  fetchProducts() {
    fetch(this.dataset.url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
        }

        this.classList.add('product-recommendations--loaded');
      })
      .catch(e => {
        console.error(e);
      });
  }
  connectedCallback() {
    this.fetchProducts();
  }
}

customElements.define('product-recommendations', ProductRecommendations);

/**
 *  @class
 *  @function ResizeSelect
 */
if (!customElements.get('resize-select')) {
  class ResizeSelect extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.select = this.querySelector('select');
      if (!this.select) return;
      this.addEventListener('change', this.resizeSelect.bind(this));
      const details = this.closest('details');
      if (details) {
        details.addEventListener('toggle', () => {
          if (details.open) this.resizeSelect();
        });
      }
      this.resizeSelect();
    }

    resizeSelect() {
      let computed = window.getComputedStyle(this.select);
      let span = document.createElement('span');
      span.style.cssText = 'visibility:hidden;position:absolute;white-space:nowrap;pointer-events:none;font-size:' + computed.fontSize + ';font-family:' + computed.fontFamily + ';font-weight:' + computed.fontWeight + ';letter-spacing:' + computed.letterSpacing;
      span.textContent = this.select.selectedOptions[0].textContent;
      this.appendChild(span);

      requestAnimationFrame(() => {
        let paddingLeft = parseFloat(computed.paddingLeft) || 0;
        let paddingRight = parseFloat(computed.paddingRight) || 0;
        let border = (parseFloat(computed.borderLeftWidth) || 0) + (parseFloat(computed.borderRightWidth) || 0);
        this.select.style.width = Math.ceil(span.offsetWidth + paddingLeft + paddingRight + border + 15) + 'px';
        span.remove();
      });
    }
  }
  customElements.define('resize-select', ResizeSelect);
}

/**
 *  @class
 *  @function CollapsibleRow
 */
if (!customElements.get('collapsible-row')) {
  // https://css-tricks.com/how-to-animate-the-details-element/
  class CollapsibleRow extends HTMLElement {
    constructor() {
      super();

      this.details = this.querySelector('details');
      this.summary = this.querySelector('summary');
      this.content = this.querySelector('.collapsible__content');

      // Store the animation object (so we can cancel it if needed)
      this.animation = null;
      // Store if the element is closing
      this.isClosing = false;
      // Store if the element is expanding
      this.isExpanding = false;
    }
    connectedCallback() {
      this.setListeners();
    }
    setListeners() {
      this.querySelector('summary').addEventListener('click', (e) => this.onClick(e));
    }
    prepareAnimations() {
      let _this = this,
        summary_height = this.querySelector('summary').offsetHeight,
        content_height = this.querySelector('.collapsible__content').offsetHeight,
        initial_height = summary_height,
        final_height = summary_height + content_height;

      this.tl = false;
      this.tl = gsap.timeline({
        reversed: !_this.details.open,
        paused: true,
        inherit: false,
        ease: 'none',
        onStart: function () {
          _this.details.open = true;
          _this.details.style.overflow = 'hidden';
        },
        onReverseComplete: function () {
          _this.details.open = false;
          _this.details.style.overflow = '';
        }
      });

      this.tl
        .fromTo(_this.details, {
          height: function () {
            let h = Math.max(Math.max(initial_height, 0), 24);
            return h;
          },
          clearProps: 'height'
        }, {
          duration: 0.4,
          height: final_height,
          clearProps: 'height'
        });

      if (this.details.open) {
        this.tl.progress(1);
      }
    }
    instantClose() {
      this.tl.timeScale(10).reverse();
    }
    animateClose() {
      this.tl.timeScale(3).reverse();
    }
    animateOpen() {
      this.tl.timeScale(1).play();
    }
    onClick(e) {
      // Stop default behaviour from the browser
      e.preventDefault();
      // Add an overflow on the <details> to avoid content overflowing
      this.details.style.overflow = 'hidden';
      // Check if the element is being closed or is already closed
      if (this.isClosing || !this.details.open) {
        this.open();
        // Check if the element is being openned or is already open
      } else if (this.isExpanding || this.details.open) {
        this.shrink();
      }
    }
    shrink() {
      // Set the element as "being closed"
      this.isClosing = true;

      // Store the current height of the element
      const startHeight = `${this.details.offsetHeight}px`;
      // Calculate the height of the summary
      const endHeight = `${this.summary.offsetHeight}px`;

      // If there is already an animation running
      if (this.animation) {
        // Cancel the current animation
        this.animation.cancel();
      }

      // Start a WAAPI animation
      this.animation = this.details.animate({
        // Set the keyframes from the startHeight to endHeight
        height: [startHeight, endHeight]
      }, {
        duration: 250,
        easing: 'ease'
      });

      // When the animation is complete, call onAnimationFinish()
      this.animation.onfinish = () => this.onAnimationFinish(false);
      // If the animation is cancelled, isClosing variable is set to false
      this.animation.oncancel = () => this.isClosing = false;
    }

    open() {
      // Apply a fixed height on the element
      this.details.style.height = `${this.details.offsetHeight}px`;
      // Force the [open] attribute on the details element
      this.details.open = true;
      // Wait for the next frame to call the expand function
      window.requestAnimationFrame(() => this.expand());
    }

    expand() {
      // Set the element as "being expanding"
      this.isExpanding = true;
      // Get the current fixed height of the element
      const startHeight = `${this.details.offsetHeight}px`;
      // Calculate the open height of the element (summary height + content height)
      const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;

      // If there is already an animation running
      if (this.animation) {
        // Cancel the current animation
        this.animation.cancel();
      }

      // Start a WAAPI animation
      this.animation = this.details.animate({
        // Set the keyframes from the startHeight to endHeight
        height: [startHeight, endHeight]
      }, {
        duration: 400,
        easing: 'ease-out'
      });
      // When the animation is complete, call onAnimationFinish()
      this.animation.onfinish = () => this.onAnimationFinish(true);
      // If the animation is cancelled, isExpanding variable is set to false
      this.animation.oncancel = () => this.isExpanding = false;
    }

    onAnimationFinish(open) {
      // Set the open attribute based on the parameter
      this.details.open = open;
      // Clear the stored animation
      this.animation = null;
      // Reset isClosing & isExpanding
      this.isClosing = false;
      this.isExpanding = false;
      // Remove the overflow hidden and the fixed height
      this.details.style.height = this.details.style.overflow = '';
    }
  }
  customElements.define('collapsible-row', CollapsibleRow);
}

/**
 *  @function addIdToRecentlyViewed
 */
function addIdToRecentlyViewed(handle) {

  if (!handle) {
    let product = document.querySelector('.thb-product-detail');

    if (product) {
      handle = product.dataset.handle;
    }
  }
  if (!handle) {
    return;
  }
  if (window.localStorage) {
    let recentIds = window.localStorage.getItem('recently-viewed');
    if (recentIds != 'undefined' && recentIds != null) {
      window.recentlyViewedIds = JSON.parse(recentIds);
    }
  }
  // Remove current product if already in recently viewed array
  var i = window.recentlyViewedIds.indexOf(handle);

  if (i > -1) {
    window.recentlyViewedIds.splice(i, 1);
  }

  // Add id to array
  window.recentlyViewedIds.unshift(handle);

  if (window.localStorage) {
    window.localStorage.setItem('recently-viewed', JSON.stringify(window.recentlyViewedIds));
  }
}

/**
 *  Shopify standard events — adapters
 *  Translate the theme's internal events into shopify:* standard events
 *  in one place, instead of editing each dispatch site.
 */
document.addEventListener('cart:item-added', (event) => {
  const item = event.detail && event.detail.product;
  const payload = {
    action: 'add',
    promise: Promise.resolve({ cart: null })
  };
  if (item && item.variant_id) {
    payload.lines = [{ merchandiseId: item.variant_id, quantity: item.quantity || 1 }];
  }
  publishStandardEvent('CartLinesUpdateEvent', payload);
});

document.addEventListener('line-item:change:end', (event) => {
  const detail = event.detail || {};
  publishStandardEvent('CartLinesUpdateEvent', {
    action: parseInt(detail.quantity, 10) === 0 ? 'remove' : 'update',
    promise: Promise.resolve({ cart: standardEventCart(detail.cart) })
  });
});

document.addEventListener('cart-drawer:open', () => {
  // The one intentional /cart.js request: tiny, user triggered, and only
  // made when the standard events module is present.
  if (!(window.Shopify && window.Shopify.StandardEvents)) return;
  fetch(`${theme.routes.cart_url}.js`)
    .then((response) => response.json())
    .then((cart) => {
      publishStandardEvent('CartViewEvent', {
        cart: standardEventCart(cart),
        context: 'dialog'
      });
    })
    .catch(() => {});
});

document.addEventListener('product:variant-error', (event) => {
  const detail = event.detail || {};
  publishStandardEvent('CartErrorEvent', {
    error: detail.errors || detail.message || 'Cart error',
    code: 'add_to_cart_error'
  });
});

document.addEventListener('DOMContentLoaded', () => {
});



